import React from 'react';
import { Heading, Text, Strong } from 'components/core/Typography';
import { Stack } from 'components/layout';

type ResolveVoteInfoProps = {
  name1?: string;
  name2?: string;
  showPrompt?: boolean;
};
const ResolveVoteInfo = ({
  name1,
  name2,
  showPrompt = true,
}: ResolveVoteInfoProps) => {
  return (
    <Stack spacing={3}>
      <Stack spacing={2}>
        {name1 && (
          <Text variant="neutral" size="sm">
            <Strong>{name1}</Strong> voted
          </Text>
        )}
        {name2 && (
          <Text variant="neutral" size="sm">
            <Strong>{name2}</Strong> voted
          </Text>
        )}
      </Stack>
      {showPrompt && (
        <Stack spacing={2}>
          <Heading variant="brand" type="h6" component="h4">
            Final decision
          </Heading>
          <Text variant="brand">What was the agreed final decision?</Text>
        </Stack>
      )}
    </Stack>
  );
};

export default ResolveVoteInfo;
